import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { LOGO_URL } from "@/lib/brand";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [u, setU] = useState("");
  const [p, setP] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(u, p);
      toast.success("Welcome back");
      nav("/admin");
    } catch {
      toast.error("Invalid credentials");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-brand-ivory flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="max-w-md w-full bg-white rounded-3xl shadow-lg border border-brand-maroon/10 p-8 sm:p-10">
        <Link to="/" className="flex items-center gap-3 mb-8">
          <img src={LOGO_URL} alt="Furshala" className="w-14 h-14 object-contain" />
          <div>
            <div className="font-serif text-2xl text-brand-maroon">Furshala</div>
            <div className="text-[10px] uppercase tracking-[0.28em] text-brand-gold font-semibold">Admin</div>
          </div>
        </Link>
        <h1 className="font-serif text-3xl text-brand-soft">Welcome back.</h1>
        <p className="text-sm text-brand-soft/60 mt-1">Sign in to manage events, shop, and bookings.</p>

        <form onSubmit={submit} className="mt-8 space-y-4" data-testid="admin-login-form">
          <label className="block">
            <div className="text-sm font-medium text-brand-soft mb-1.5">Username</div>
            <input value={u} onChange={(e) => setU(e.target.value)} required className="w-full bg-brand-ivory rounded-xl px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-brand-mustard/40" data-testid="login-username" />
          </label>
          <label className="block">
            <div className="text-sm font-medium text-brand-soft mb-1.5">Password</div>
            <input type="password" value={p} onChange={(e) => setP(e.target.value)} required className="w-full bg-brand-ivory rounded-xl px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-brand-mustard/40" data-testid="login-password" />
          </label>
          <button type="submit" disabled={busy} className="btn-primary-furshala w-full inline-flex items-center justify-center gap-2 disabled:opacity-60" data-testid="login-submit">
            <Lock className="w-4 h-4" /> {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
